<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="模板" prop="templateId">
          <el-input v-model="dataForm.templateId" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="发送人" prop="sender">
          <el-input v-model="dataForm.sender" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="接收" prop="receiver">
          <el-input v-model="dataForm.receiver" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="主题" prop="theme">
          <el-input v-model="dataForm.theme" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
          <el-select v-model="dataForm.status" placeholder="请选择">
            <el-option 
              v-for="item in statusList" 
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        templateId: '',
        sender: '',
        receiver: '',
        theme: '',
        status: '',
        creator: '',
        createDate: ''
      },
      statusList:[
        {
          label: '禁用',
          value: 0,
        },
        {
          label: '启用',
          value: 1,
        },
      ],
    }
  },
  computed: {
    dataRule () {
      return {
        templateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sender: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        receiver: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        theme: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/mailrecord/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/mailrecord/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
